/**
 * Azure AppInsights init.
 * See: https://github.com/microsoft/ApplicationInsights-JS
 * See: https://github.com/microsoft/applicationinsights-react-js
 */
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { env } from '../../env';

export const reactPlugin = new ReactPlugin();
export const appInsightsInstance = new ApplicationInsights({
	config: {
		connectionString: env.azure.connectionString,
		extensions: [reactPlugin as any],
		enableAutoRouteTracking: false, // we send PageView event manually in [[...slug]].tsx
		autoTrackPageVisitTime: true,
	},
});

if (env.azure.connectionString) {
	appInsightsInstance.loadAppInsights();
}
